import React, { FC } from 'react';
import CustomModal from 'components/customModal/CustomModal';
import Styles from './WelcomeModal.module.scss';

interface WelcomeModalProps {
  name?: string;
  onClose: () => void;
}

// Full welcome copy (everything after the "Hi <name>," greeting, which is
// rendered separately so the name can be highlighted). Mirrors the in-app
// Admin Messages notification seeded at signup.
const buildRest = (): string =>
  `welcome to Moderate Politics — we're so glad you're here!\n\n` +
  `Moderate Politics is a space for balanced, respectful political conversation. Here's how to get started:\n\n` +
  `• Join or start a conversation room to talk with people near you.\n` +
  `• Explore the latest pieces in the "MODERATE POLITICS ARTICLES & INFORMATION" and "NEWS AGGREGATOR" sections.\n` +
  `• Keep an eye on this Admin Messages box — it's where we'll post important updates.\n\n` +
  `We're just getting started and will be rolling out more features soon. Thanks for being one of our first members!\n\n` +
  `— The Moderate Politics Team`;

const WelcomeModal: FC<WelcomeModalProps> = ({ name, onClose }) => {
  const greetingName = name && name.trim() ? name.trim() : 'there';

  return (
    <CustomModal
      closeDialog={onClose}
      wrapperClass={Styles.welcomeModal}
      cssClass={Styles.welcomeBody}
      hideHeaderBorder
      modalHeaderClass={Styles.noHeader}
    >
      <h2 className={Styles.title}>{`Welcome to Moderate Politics!`}</h2>
      <p className={Styles.body}>
        Hi <span className={Styles.name}>{greetingName}</span>, {buildRest()}
      </p>
      <button type="button" className={Styles.gotItBtn} onClick={onClose}>
        Got it
      </button>
    </CustomModal>
  );
};

export default WelcomeModal;
